
<template>
    <v-dialog v-model="visible" persistent max-width="300">
        <v-card>
            <v-card-title class="headline justify-center">
                <v-icon color="primary" style="font-size: 80px;">
                    mdi-emoticon-confused-outline
                </v-icon>
                {{ $t('estoque.indisponivelTitulo') }}
            </v-card-title>

            <v-card-text class="text-center">
                <ul class="my-2" style="list-style-type: none; padding: 0;">
                    <li v-for="(item, i) in value.inactiveItems" :key="i" style="font-weight: bold;">
                        {{ item.descricao }}
                    </li>
                </ul>

                <span class="mt-4">
                    <br>{{ $t('estoque.indisponivelTexto') }}<br><br>

                    {{ $t('estoque.indisponivelRemovidos') }}
                </span>
            </v-card-text>

            <v-card-actions>
                <v-btn
                    @click="voltar"
                    color="primary"
                    class="white--text"
                    block
                >{{ $t('estoque.voltarAoCardapio') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
    name: 'InactiveItemDialog',

    props: {
        value: {
            type: Object,
        },
        visible: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        ...mapMutations({
            setInitialized: 'setInitialized',
        }),

        voltar() {
            this.setInitialized(false);

            this.$emit('onGoBack');
            // this.$emit('close');
        },
    },
}
</script>

<style scoped>
</style>
